import { BALANCE, ringOf, type Action, type BuildableModuleType, type Cell } from "@station-keeping/sim";
import { t } from "../i18n";
import { errorLabel, moduleName } from "../ui/labels";
import { getEngine } from "./runtime";
import { useGameUi } from "./store";

/** Joue une action ; une action refusée s'explique dans un toast. Renvoie vrai si elle est passée. */
export function play(action: Action): boolean {
  const engine = getEngine();
  if (!engine) return false;
  const result = engine.dispatch(action);
  if (!result.ok) useGameUi.getState().toast(errorLabel(result.code), "warn");
  return result.ok;
}

export function build(type: BuildableModuleType, cell: Cell): boolean {
  const ok = play({ type: "BUILD", module: type, x: cell.x, y: cell.y });
  if (ok) {
    const ui = useGameUi.getState();
    ui.cancelBuild();
    ui.toast(t("build.built", { module: moduleName(type) }), "good");
  }
  return ok;
}

/**
 * Toucher une case : en mode construction, on construit ; sinon on ouvre la fiche du module qui s'y trouve,
 * et une case vide ferme ce qui est ouvert (toucher la carte, c'est sortir du panneau).
 */
export function tapCell(cell: Cell): void {
  const engine = getEngine();
  if (!engine) return;
  const ui = useGameUi.getState();
  ui.setCursor(cell);
  if (ui.buildType) {
    build(ui.buildType, cell);
    return;
  }
  const module = engine.state.modules.find((candidate) => candidate.x === cell.x && candidate.y === cell.y);
  if (module) ui.select(module.id);
  else ui.closeAll();
}

/** Déplace le curseur clavier d'une case, sans sortir des anneaux ouverts (la vue ne va pas plus loin). */
export function moveCursor(dx: number, dy: number): Cell {
  const ui = useGameUi.getState();
  const max = getEngine()?.state.openRings ?? BALANCE.grid.maxRing;
  const next = {
    x: Math.max(-max, Math.min(max, ui.cursor.x + dx)),
    y: Math.max(-max, Math.min(max, ui.cursor.y + dy)),
  };
  ui.setCursor(next);
  return next;
}

export function isInsideGrid(cell: Cell): boolean {
  return ringOf(cell.x, cell.y) <= BALANCE.grid.maxRing;
}
